<template>
	<div class="animated fadeIn">
		<CommandHeaderV2 :command_service_id="serviceId" :record_id="commandId" active="advertises">
			<div class="pt-3 pr-3 pb-0 pl-3">
				<b-button variant="dark" class="pull-right pull-right mx-0" @click="addNew">
					<font-awesome-icon icon="plus" />
					{{$t('new_advertise')}}
				</b-button>

				<div class="clearfix"></div>

				<response-extra-ads
					:header="`ad`"
					v-for="(advertise, i) in advertises"
					:key="`advertises-${i}`"
					@change="e => handleOnChange(e, i)"
					@save="e => validate(save, i)"
					@remove="e => remove(e, i)"
					@cancel="e => cancel(i)"
					:dataSet="advertise"
				></response-extra-ads>  
			</div>
		</CommandHeaderV2>
	</div>
</template>
<script>
	import axios from 'axios'
	import cSwitch from '../../../components/Switch'
	import CommandHeaderV2 from '../../../components/CommandHeaderV2'
	import Utilities from '../../../directives/Autocomplete/Utilities'
	import buttonSave from '../../../components/ButtonSave'
	import ResponseExtraAds from '../../../components/responseExtraAds'

	/**
	 * @vuese
	 *
	 * @group Advertises
	 *
	 * Advertise Form
	 *
	 */
	export default {
		name: 'AdvertiseForm',
		components: {
			cSwitch,
			CommandHeaderV2,
			buttonSave,
			ResponseExtraAds,
		},
		data() {
			return {
				/**
				 * @vuese
				 *
				 * @type {Integer}
				 */
				commandId: 0,
				/**
				 * @vuese
				 *
				 * @type {Integer}
				 */
				serviceId: 0,
				/**
				 * @vuese
				 *
				 * List of advertises
				 *
				 * @type {Array}
				 */
				advertises: [],
			}
		},
		methods: {
			/**
			 * @vuese
			 *
			 * Validate advertise
			 *
			 * @arg   {Function}  cb  Callback after passing validation
			 *
			 * @return  {void}
			 */
			validate(cb) {
				const advertises = this.advertises.slice().filter((ad) => ad.code.length)
				advertises.length && cb(this.advertises)
			},

			/**
			 * @vuese
			 *
			 * Save Advertise
			 *
			 * @arg   {Array}  advertises
			 *
			 * @return  {void}
			 */
			save(advertises) {
				this.$root.loader = true
				axios
					.post('/command_advertises/save/' + this.commandId, {data: advertises})
					.then(({data}) => {
						this.advertises = data.data
					})
					.finally((e) => {
						this.$root.loader = !true
					})
			},

			/**
			 * @vuese
			 *
			 * Keeps advertises synchronized
			 *
			 * @arg   {Object}  data
			 * @arg   {Integer}  i
			 *
			 */
			handleOnChange(data, i) {
				this.advertises[i] && (this.advertises[i] = data)
			},

			/**
			 * @vuese
			 *
			 * Get list of advetises
			 */
			async getAdvertises() {
				let commandId
				if (
					parseInt((this.commandId = this.$route.params.command_id)) &&
					parseInt((this.serviceId = this.$route.params.service_id))
				) {
					const {data} = await axios.get('/command_advertises/get/' + this.commandId)
					this.advertises = data.data.length ? data.data : this.emptyAd()
					return 1
				}
				throw new Error('Undefined command or service ids')
			},

			handleError() {
				this.$router.push({path: '/404'})
			},

			/**
			 * @vuese
			 *
			 *
			 * Reset advertise form
			 */
			emptyAd() {
				return [
					{
						code: '',
						status: 0,
						random: 0,
						random_ratio: '10',
					},
				].slice()
			},

			/**
			 * @vuese
			 *
			 *
			 * Remove advertise from the list
			 *
			 * @arg   {Object}  ad
			 * @arg   {Integer}  i
			 *
			 */
			remove(ad, i) {
				this.cancel(i)
				this.advertises = !this.advertises.length ? this.emptyAd() : this.advertises
				ad.id && axios.delete('/command_advertises/' + ad.id)
			},

			cancel(i) {
				this.advertises[i] && this.advertises.splice(i, 1)
			},

			/**
			 * @vuese
			 *
			 * Push new advertise
			 */
			addNew() {
				this.advertises = this.advertises.concat(this.emptyAd())
			},
		},

		async created() {
			try {
				this.$root.loader = true
				await this.getAdvertises()
				this.$root.loader = false
			} catch (error) {
				this.handleError()
			}
		},
	}
</script>
